namespace RioERP.Web.Enums {
    export enum EValidityType {
        FixedDate = 1,
        ValidityInDays = 2
    }
    Serenity.Decorators.registerEnumType(EValidityType, 'RioERP.Web.Enums.EValidityType');
}
